module.exports = __webpack_public_path__ + "img/erweima_kf_jj.64d95bcb.png";